/**
 * 状态监听
 *  code=> callingState: 0默认状态，1呼叫中 2正在通话
 *  目前没有声网返回的状态，也没有对齐进行监听
 */
export default class StateListenService {
  constructor(state) {
    this.state = state;
    this._stateMap = {
      100: { callingState: 1 },
      110: { callingState: 1 },

      120: { stateCode: 120, callingState: 1 }, // 开始获对方用户信息
      140: { callingState: 2 }, // 开始获对方用户信息
      145: { callingState: 2 }, // 开始获对方用户信息

      170: { callingState: 0, toastText: '对方已挂断' }, // 顾问离开，C端收到通知
      180: { callingState: 0, toastText: '对方已挂断' }, // C端离开，顾问收到通知
      200: { callingState: 0, toastText: '通话已中断' },

      168: { stateCode: 168, toastText: '对方网络异常，请稍后' },
      // 158: { toastText: '对方网络异常，请稍后' }, // 暂时没有用
      130: { toastText: '顾问正忙，请您稍候重试' }, // 顾问拒绝接听
      166: { toastText: '顾问正忙，请您稍候重试' }, // 顾问没有麦克风权限
      169: { toastText: '顾问正忙，请您稍候重试' }, // 顾问被占用

      // 4、建立链接后，对方APP切入后台，toast弹层提示“屏幕链接已断开，请稍后”。语音链接不断开。
      150: { stateCode: 150, toastText: '屏幕链接已断开，请稍后' },
      160: { stateCode: 160, toastText: '屏幕链接已断开，请稍后' },
      // 2、 B端163、C端153接听电话打断，toast弹层提示“对方电话中，请稍候”。，语音链接不断开
      163: { stateCode: 163, toastText: '对方电话中，请稍候' },
      153: { stateCode: 153, toastText: '对方电话中，请稍候' }, // 不做监听
    };
    // 声网状态和服务器返回的状态的映射，映射数据暂定，确定后，多余注释删除

    this._stateSound = {
      A1001: 140,
      A1002: 170,
      A1003: 200,
      'R100-1': 300,
      R1000: 310,
      R1001: 320,
      R1002: 330,
      R1003: 340,
      R1004: 350,
      R1005: 360,
      R1009: 370,
    };
  }
  // 声网状态和服务器返回的状态的转换
  getTransformState() {
    if (this.state) {
      this.state = this._stateSound[this.state];
      return this.state;
    }
    return 0;
  }
  // 获取状态 带参数是服务器获取，参数为null是声网获取用
  getState(state) {
    if (state) {
      this.state = state;
    }
    return this._stateMap[this.state];
  }
}
/**
 *   以下是声网的扬声器状态枚举
 */
export const speakerState = {
  routeDefault: 300, // -1 "R100-1": 默认的音频线路
  routeHeadset: 310, // 0 "R1000": 音频路由是带麦克风的耳机--有线耳机
  routeEarPiece: 320, // 1 "R1001": 音频线路是一个耳机-- 听筒
  routeHeadsetNoMic: 330, // 2 "R1002": 音频路由是一个没有麦克风的耳机
  routeSpeakerPhone: 340, // 3 "R1003": 音频路径是设备自带的扬声器-- 扬声器
  routeHeadsetBluetooth: 350, // 4 "R1004": 音频路由是蓝牙耳机
  routebluetoothVoice: 360, // "R1005": 使用蓝牙耳机为语音路由 -- 蓝牙耳机
  routeappleAairPlayFV: 370, // "R1009": 音频路径是Apple AirPlay 苹果手机的空投
};
